/**
 * Высота @uiw/react-md-editor в режиме «auto»: тулбар + scrollHeight textarea.
 * При вложенных диалогах учитывать RemoveScroll и overscroll-behavior.
 */
export const MARKDOWN_EDITOR_AUTO_HEIGHT = {
  textMinPx: 120,
  textHardMaxPx: 560,
  textMaxViewportFraction: 0.5
} as const;

export function markdownEditorTextMaxPx(innerHeight: number): number {
  const { textHardMaxPx, textMaxViewportFraction } = MARKDOWN_EDITOR_AUTO_HEIGHT;
  return Math.round(Math.min(textHardMaxPx, innerHeight * textMaxViewportFraction));
}

export function measureMarkdownEditorTotalHeightPx(
  root: HTMLElement,
  toolbarPx: number,
  textMinPx: number,
  textMaxPx: number
): number | null {
  const ta = root.querySelector('textarea.w-md-editor-text-input');
  if (!ta || !(ta instanceof HTMLTextAreaElement)) return null;

  const saved = {
    height: ta.style.height,
    minHeight: ta.style.minHeight,
    maxHeight: ta.style.maxHeight,
    overflow: ta.style.overflow
  };
  ta.style.height = 'auto';
  ta.style.minHeight = '0';
  ta.style.maxHeight = 'none';
  ta.style.overflow = 'hidden';
  const scroll = ta.scrollHeight;
  ta.style.height = saved.height;
  ta.style.minHeight = saved.minHeight;
  ta.style.maxHeight = saved.maxHeight;
  ta.style.overflow = saved.overflow;

  const textBlock = Math.min(textMaxPx, Math.max(textMinPx, scroll));
  return toolbarPx + textBlock;
}
